export default {
  slug: "codecanvas",
  code: "CC",
  label: "CodeCanvas",
  logoFamily: "jb",
};
